export default function abacus(state = {}, {type}) {
    switch (type) {
        default:
            return state;
    }
}
